import React from 'react';

import { DatePickerProps } from 'antd';
import moment, { Moment } from 'moment';

import { Button } from 'components/Button';
import { DatePicker } from 'components/DatePicker';

export interface QuickButton {
  name: string;
  value: Moment;
}

const isPast = (date: Moment) =>
  // Can not select days before today
  date && date < moment().startOf('day');

/**
 * IsoDatePicker takes date value as ISO 8601 strings, and returns date changes as strings
 */
export function IsoDatePicker({
  value,
  onChange,
  quickButtons,
  showTime,
  disabledDates = isPast,
  ...otherProps
}: {
  value?: string;
  onChange?: (newValue: string) => void;
  quickButtons?: QuickButton[];
  showTime?: boolean;
  disabledDates?: (date: Moment) => boolean;
} & Omit<DatePickerProps, 'value' | 'onChange'>) {
  return (
    <>
      <DatePicker
        disabledDate={disabledDates}
        value={moment(value)}
        onChange={(newValue) => {
          if (newValue && onChange) {
            onChange(showTime ? newValue.toISOString() : newValue.startOf('day').toISOString());
          }
        }}
        showTime={showTime}
        {...otherProps}
      />
      {quickButtons &&
        quickButtons.map((qb) => (
          <Button
            style={{ marginLeft: '10px' }}
            key={qb.name}
            onClick={() => onChange?.(qb.value.startOf('day').toISOString())}
          >
            {qb.name}
          </Button>
        ))}
    </>
  );
}
